module.exports = __webpack_public_path__ + "static/media/PoLoBao.ba8d3bfa.jpg";